import type { ReactNode } from 'react';
import classNames from 'styles/utils/classNames';

interface Props {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

/**
 * A selectable grey tile (Figma "Filter elements"): white with the dark ring and
 * shadow when picked. The day and time pickers in the request form use it; the
 * court picker is its image-topped sibling, `LocationCard`.
 */
export default function OptionTile({ selected, onClick, children, className }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={classNames(
        'flex min-w-0 flex-1 items-center justify-center rounded-lg p-ds-md transition-colors',
        selected
          ? 'border border-color-border-selected-lightmode bg-color-bg-lightmode-primary shadow-[0px_4px_10px_0px_rgba(0,0,0,0.16)] dark:border-color-border-selected-darkmode dark:bg-color-bg-darkmode-primary'
          : 'bg-color-bg-lightmode-secondary dark:bg-color-bg-darkmode-secondary',
        className,
      )}
    >
      {children}
    </button>
  );
}
